import api from './api';

export interface Banner {
  id: string;
  desktop_image_url: string;
  mobile_image_url: string;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface BannerFormData {
  active: boolean;
}

class BannerService {
  // Obtener banners públicos (activos)
  async getBanners() {
    const response = await api.get('/banners');
    return response.data;
  }

  // Obtener todos los banners (admin)
  async getAllBanners() {
    const response = await api.get('/banners/admin/all');
    return response.data;
  }

  // Obtener banner por ID
  async getBannerById(id: string) {
    const response = await api.get(`/banners/${id}`);
    return response.data;
  }

  // Crear nuevo banner
  async createBanner(formData: FormData) {
    const response = await api.post('/banners', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // Actualizar banner
  async updateBanner(id: string, formData: FormData) {
    const response = await api.put(`/banners/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // Eliminar banner
  async deleteBanner(id: string) {
    const response = await api.delete(`/banners/${id}`);
    return response.data;
  }

  // Actualizar orden de banners
  async updateBannerOrder(banners: { id: string; position: number }[]) {
    const response = await api.post('/banners/order', { banners });
    return response.data;
  }
}

export const bannerService = new BannerService();